import React, { useEffect } from 'react';
import { Card, Form, Space, Input, Tooltip } from 'antd';

import { formItemLayout } from '../Common';
import { isEmpty } from 'script/common';

const ProductName = ({ t, settingKey, settingData, onSave, message }) => {
	const [form] = Form.useForm();

	const initialValues = {
		['data']: settingData?.value || ''
	}

	useEffect(() => {
		if (typeof settingData === 'string') {
			form.setFieldsValue({
				data: settingData
			});
		} else if (settingData && settingData.value) {
			form.setFieldsValue({
				data: settingData.value
			});
		}
	}, [settingData, form]);


	const onFinish = (e) => {
		let value = [];
		let defaultValue = "";
		let setValue = e.data;

		setValue = isEmpty(setValue) ? defaultValue : setValue.trim();

		value.push({
			key: settingKey.value,
			value: setValue
		});

		if (!isEmpty(value)) {
			onSave(value);
		}
	}

	return (
		<Form {...formItemLayout} form={form} onFinish={onFinish} initialValues={initialValues}>
			<Tooltip  title={t('setting.tooltipcontent.name.label')} placement="leftTop">
			<Card title={t(settingKey.key)} key={settingKey.key} name={['settingKey.key']} style={{ margin: 20 }}>
				<Form.Item name={['data']} >
					<Input
						className="item_input"
						id="product_name"
						autoComplete="off"
						placeholder={t('settings.msg.invalidLength')}
						maxLength={30}
					/>
				</Form.Item>
				<Space style={{ float: 'right', margin: 20 }}>
					<button className="btn_text_b">{t('user.account.save')}</button>
				</Space>
			</Card>
			</Tooltip>
		</Form>
	);
};

export default ProductName;